import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

const MultipleChoice = ({ question, selectedAnswer, onSelectAnswer, onSelectAndSubmit, showResult }) => {
  // Support both single value and array of correct answers
  const correctAnswers = Array.isArray(question.correct_answer)
    ? question.correct_answer
    : [question.correct_answer];

  return (
    <div className="space-y-3">
      {question.options?.map((option, index) => {
        const isSelected = selectedAnswer === index;
        const isCorrect = correctAnswers.includes(index);
        const showCorrect = showResult && isCorrect;
        const showIncorrect = showResult && isSelected && !isCorrect;
        
        return (
          <button
            key={index}
            onClick={() => {
              if (showResult) return;
              if (onSelectAndSubmit) {
                onSelectAndSubmit(index);
              } else {
                onSelectAnswer(index);
              }
            }}
            disabled={showResult}
            className={`w-full p-4 rounded-xl text-left transition-all duration-200 border-2 ${
              showCorrect
                ? 'bg-green-50 border-green-500'
                : showIncorrect
                ? 'bg-red-50 border-red-500'
                : isSelected
                ? 'bg-purple-50 border-purple-500'
                : 'bg-white border-gray-200 hover:border-purple-300 hover:bg-purple-50'
            } ${showResult ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          >
            <div className="flex items-center justify-between">
              <span className="text-gray-900">{option}</span>
              {showCorrect && <CheckCircle2 className="w-6 h-6 text-green-500" />}
              {showIncorrect && <XCircle className="w-6 h-6 text-red-500" />}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default MultipleChoice;

